import { render, staticRenderFns } from "./FormaPagamentoForm.vue?vue&type=template&id=2c74c1d3"
import script from "./FormaPagamentoForm.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports